import { Button, Form, Input } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { getById, queryKnowledgeBase } from '../../knowledge-base-common/actions';
import { Section } from '../../knowledge-base-common/knowledge-base-common.type';
import { fromAssistant } from '../virtual-assistant.utils';
import { ActionTypes, From, Message, UserPrompt } from '../vitrual-assistant.type';
import ChatMessage from './chat-message';
import { ChatTyping } from './chat-typing';
import { localize } from '/react4xp/mixins/helpers';
import { PartContext } from '/react4xp/parts/virtual-assistant/virtual-assistant';

interface ChatProps {
    messages: Message[];
    emailOperator: () => void;
    addMessage: (...messages: Omit<Message, 'id'>[]) => void;
    isTyping?: boolean;
}

const Chat = ({ addMessage, messages, emailOperator, isTyping }: ChatProps) => {
    const [activeSection, setActiveSection] = useState<string>(null);
    const [form] = Form.useForm<UserPrompt>();
    const { translations, kbClientUrl, serviceUrl } = useContext(PartContext);

    useEffect(() => {
        const queueMessage = (e: CustomEvent) => handleUserPrompt({ query: e.detail.query });

        window.addEventListener('assistantMessage', queueMessage);

        return () => {
            window.removeEventListener('assistantMessage', queueMessage);
        };
    }, []);

    const showArticle = (message) => {
        const { payload } = message?.action || {};
        // Create KB links for all articles
        // getById<FullArticle>(serviceUrl, id).then((article) => {
        //
        // if (article.content.length < ARTICLE_SIZE_LIMIT) {
        //     addMessage(fromAssistant(article.content));
        // } else {
        location.replace(`${kbClientUrl}?article=${payload}`);
        // }
        // });
    };

    const selectSection = (message) => {
        const { payload: id } = message?.action || {};

        addMessage({ from: From.USER, text: message.text });

        setActiveSection(id);
        getById<Section>(serviceUrl, id).then((section) =>
            addMessage(
                fromAssistant(
                    localize('messages.section-selected', translations).replace(
                        '__TITLE__',
                        section.title
                    )
                )
            )
        );
    };

    const actions: Record<ActionTypes, (message?: any) => void> = {
        [ActionTypes.KNOWLEDGE_BASE]: () => location.replace(kbClientUrl),
        [ActionTypes.SHOW_ARTICLE]: showArticle,
        [ActionTypes.EMAIL_OPERATOR]: emailOperator,
        [ActionTypes.SELECT_SECTION]: selectSection,
        [ActionTypes.TELEGRAM_BOT]: () => location.replace('https://t.me/online_chat_help_bot'),
        [ActionTypes.CONSULTATIONS]: () => location.replace('https://t.me/SalyqBot?start=poll9'),
    };

    const handleUserPrompt = ({ query }: UserPrompt) => {
        addMessage({ from: From.USER, text: query });
        form.resetFields();
        queryKnowledgeBase(serviceUrl, query, activeSection).then((articles) => {
            if (articles?.length === 0) {
                addMessage(
                    fromAssistant(localize('messages.no-results', translations)),
                    fromAssistant(localize('messages.telegram-bot', translations), {
                        type: ActionTypes.TELEGRAM_BOT,
                    }),
                    fromAssistant(localize('messages.kb-link', translations), {
                        type: ActionTypes.KNOWLEDGE_BASE,
                    }),
                    fromAssistant(localize('messages.operator', translations), {
                        type: ActionTypes.EMAIL_OPERATOR,
                    })
                );
            }
            // Always show content as a link to knowledge base to avoid saving full content to local storage
            // if (articles.length === 1) {
            //     if (articles[0].content.length < ARTICLE_SIZE_LIMIT) {
            //         addMessage(fromAssistant([articles[0].title, articles[0].content].join(': ')));
            //     } else {
            //         addMessage({
            //             from: From.ASSISTANT,
            //             text: articles[0].title,
            //             action: { type: ActionTypes.SHOW_ARTICLE, payload: articles[0].id },
            //         });
            //     }
            // } else
            else {
                addMessage(
                    ...articles.map((article) => ({
                        from: From.ASSISTANT,
                        text: article.title,
                        action: { type: ActionTypes.SHOW_ARTICLE, payload: article.id },
                    }))
                );
            }
        });
    };

    return (
        <>
            <ul className="messages-container">
                {isTyping && <ChatTyping />}
                {messages?.map((message, index) => {
                    const currentFrom = message.from;
                    const nextMessage = messages[index - 1];
                    const nextFrom = nextMessage?.from;

                    const showAvatar = currentFrom !== nextFrom;
                    const action = message.action
                        ? {
                              action: () => actions[message.action.type](message),
                          }
                        : {};
                    return (
                        <ChatMessage
                            showAvatar={showAvatar}
                            key={message.id}
                            message={message}
                            {...action}
                        />
                    );
                })}
            </ul>
            <Form
                layout="inline"
                form={form}
                onFinish={handleUserPrompt}
                style={{ padding: '0.5rem 1rem' }}
            >
                <Form.Item
                    name="query"
                    className="query"
                    style={{ flex: 1 }}
                >
                    <Input.TextArea
                        required
                        placeholder={localize('placeholders.query', translations)}
                    />
                </Form.Item>
                <Button
                    htmlType="submit"
                    type="text"
                    style={{
                        color: '#3457B1',
                    }}
                >
                    {localize('button.send', translations)}
                </Button>
            </Form>
        </>
    );
};

export default Chat;
